/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'
import { parse } from 'query-string'

import Feature from '@modules/utils/feature'
import { getBearerToken } from '@modules/auth/auth'
import withRouter from '@modules/routing/withRouter'

import { getAuthMethods } from '@/reducers/authMethods'
import { fetchAuthMethodsRequest, getLoginRequest } from '@/reducers/asyncRequests/registry'

import { fetchAuthMethods, redirectAfterLogin } from '../../../../../actions/auth'
import { isFeatureActivated } from '../../../../../selectors'

import SsoBasedLogin from './SsoBasedLogin'

import type { ReduxState } from '@/types/redux'
import type { ConsumerProps, DispatchProps, StateProps } from './types'

const mapStateToProps = (
  state: ReduxState,
  { router: { location } }: ConsumerProps,
): StateProps => {
  const { hash } = location
  const { redirectTo } = parse(location.search.slice(1))
  const basicAuthProxyPassEnabled = isFeatureActivated(state, Feature.basicAuthProxyPass)
  const newBearerToken = basicAuthProxyPassEnabled ? getBearerToken(hash) : null

  return {
    redirectTo: typeof redirectTo === `string` ? redirectTo : undefined,
    authMethods: getAuthMethods(state),
    loginRequest: getLoginRequest(state),
    fetchAuthMethodsRequest: fetchAuthMethodsRequest(state),
    newBearerToken,
  }
}

const mapDispatchToProps = {
  fetchAuthMethods,
  redirectAfterLogin,
}

export default withRouter(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(SsoBasedLogin),
)
